import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { type CustomerProductRating, StatusCode } from '@hungryroot/rest';
import {
  postApiV2CustomersCustomerIdProductRatings,
  type ProductPayload,
  type CustomerProductRating as ProductResponse,
} from '@hungryroot/rest/api/v2/customers/[id]/product_ratings/post';

type UsePostCustomerProductRatingsProps<Context> = Omit<
  UseMutationOptions<
    CustomerProductRating,
    Error,
    { customerId: number; payload: ProductPayload },
    Context
  >,
  'mutationFn'
>;

export function usePostCustomerProductRatings<Context>(
  props?: UsePostCustomerProductRatingsProps<Context>
) {
  return useMutation({
    mutationFn: async (params: {
      customerId: number;
      payload: ProductPayload;
    }) => {
      const { customerId, payload } = params;
      const res = await postApiV2CustomersCustomerIdProductRatings(
        customerId,
        payload
      );
      if (res.status !== StatusCode.SuccessCreated) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data as ProductResponse;
    },
    ...props,
  });
}
